<section class="content">

  <div class="row" style="margin-top: 8%;">
      <div class="col-md-12 text-center">
          
          <div style="margin-bottom: 10px;"><img src="./assets/images/under_construction.png" /></div>
          <p style="font-size: 2.5em; margin-bottom: 0px;">Desculpe</p>
          <p style="font-size: 1.2em; color:#808080">ainda estamos construindo esta página</p>
          <br />
          <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/home64.png" /></a>
          <p style="color: #808080;">Página Inicial</p>
          
      </div>
  </div>

</section>